module.exports = __webpack_public_path__ + "static/media/taco-4.c7e812e6.jpg";